"use client";

import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";

import authStyles from "@/route-assets/login/_AuthCallback.module.scss";
import loginStyles from "@/route-assets/login/_LoginRedirect.module.scss";
import { LOGIN_SIDE_IMAGE_URL } from "@/route-assets/login/loginSideImageUrl";

import styles from "./_NotFound.module.scss";

export default function NotFound() {
  return (
    <div className={styles.overlay} role="main">
      <div className={loginStyles.page}>
        <div className={loginStyles.authBox}>
          <div className={loginStyles.inner}>
            <div className={loginStyles.card}>
              <div className={loginStyles.row}>
                <div className={loginStyles.colForm}>
                  <div className={`${loginStyles.cardBody} ${authStyles.errorCardBody}`}>
                    <div className={authStyles.errorPanel}>
                      <div className={authStyles.errorIconWrap} aria-hidden>
                        <FontAwesomeIcon icon={faCircleXmark} className={authStyles.errorIcon} />
                      </div>
                      <p className={authStyles.errorCode}>HTTP 404</p>
                      <h1 className={authStyles.errorTitle}>Page not found</h1>
                      <p className={authStyles.errorDescription}>
                        Oops! This page does not exist. Please go back and try again, or return to
                        your dashboard.
                      </p>
                      <Link href="/home" className={authStyles.backBtn}>
                        Return to Dashboard
                      </Link>
                    </div>
                  </div>
                </div>

                <div className={loginStyles.colSide} aria-hidden>
                  <div className={loginStyles.sidePanel}>
                    <img
                      src={LOGIN_SIDE_IMAGE_URL}
                      alt=""
                      className={loginStyles.sideImage}
                      decoding="async"
                      style={{ objectFit: "cover", objectPosition: "center bottom" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
